import { Modal, useModals } from 'almanac-ui/Modal'
import { PropsWithChildren } from 'react'
import Styles from '../Root/Root.module.scss'
import cx from 'classnames'
import { ModalProps } from 'almanac-ui/Modal/Types'
import { Button } from 'blaze-ui/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'blaze-ui/icons'
import { AriaLabelingProps } from '@react-types/shared'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useInterruptBrowserBack } from '../useInterruptBrowserBack'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

type CancelButtonType = 'text' | 'icon'

export const Root = ({
  children,
  bodyClassName,
  wrapperRef,
  cancelButtonType = 'text',
  onClose,
  ...props
}: PropsWithChildren<
  Pick<ModalProps, 'bodyClassName' | 'wrapperRef' | 'onClose'> & { cancelButtonType?: CancelButtonType }
> &
  Pick<AriaLabelingProps, 'aria-labelledby' | 'aria-describedby'>) => {
  const { closeModal } = useModals()
  const { isMobile } = useResponsiveDesign()
  const isDesktopWizardsUpdatesOn = useFlipperFlag('desktop_wizards_updates')
  useInterruptBrowserBack()

  const handleClose = () => {
    onClose?.() || closeModal()
  }

  const cancelButton =
    cancelButtonType === 'text' ? (
      <Button onPress={handleClose} variant="secondary" size="lg">
        Cancel
      </Button>
    ) : (
      <IconButton icon={Close} onPress={handleClose} variant="secondary" size="lg" />
    )

  return (
    <Modal.Root
      size="fullscreen"
      bodyClassName={cx(Styles.root, bodyClassName)}
      aria-labelledby="wizard-header"
      {...props}
      ref={isMobile ? wrapperRef : null}
      wrapperRef={!isMobile ? wrapperRef : null}
    >
      {!isDesktopWizardsUpdatesOn && <div className={Styles.cancelButtonContainer}>{cancelButton}</div>}
      <div className={Styles.content}>{children}</div>
    </Modal.Root>
  )
}
